import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW7300Model } from '../kymw7300.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 注文単位値引クーポン一覧削除サービス
 *
 * @export DeleteCouponListService
 * @class DeleteCouponListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class DeleteCouponListService extends PlessJsonResponderSub<null> {
  private model: KYMW7300Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof DeleteCouponListService
   */
  private getBody(): PlessRequest {
    const delObj = {
      DeleteCouponList: {
        combination: this.model.couponList.map(_ => ({
          parameter: {
            CouponGoodsNo: _.couponGoodsNo,
            CouponReceiptCatalogStart: _.couponReceiptCatalogStart,
          },
        })),
      }
    };
    return new PlessRequest({ delete: delObj });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param f
   * @memberof DeleteCouponListService
   */
  execute(model: KYMW7300Model, f?: () => void): void {
    this.model = model;
    this.calbak = f;
    this.send('deleteCouponList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @memberof DeleteCouponListService
   */
  success() {
    if (this.calbak) this.calbak();
  }
}
